import { render, staticRenderFns } from "./BudgetProgress.vue?vue&type=template&id=8127bd94&"
import script from "./BudgetProgress.vue?vue&type=script&lang=js&"
export * from "./BudgetProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports